import React, { useCallback, useEffect, useState } from "react";
import Layout from "../components/Layout";
import { api } from "../lib/api";

export default function AuditLog() {
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/audit", { params: { limit: 300 } });
      setItems(data);
    } catch (err) {
      console.error("audit load failed", err);
    }
  }, []);
  useEffect(() => {
    load();
    const i = setInterval(load, 8000);
    return () => clearInterval(i);
  }, [load]);

  return (
    <Layout title="Audit Log" subtitle="GOVERNANCE">
      <div className="border border-zinc-800 rounded-sm bg-zinc-900/40">
        <div className="grid grid-cols-12 gap-3 px-4 py-2 text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500 border-b border-zinc-800 bg-zinc-900/70">
          <div className="col-span-2">TIMESTAMP</div>
          <div className="col-span-3">OPERATOR</div>
          <div className="col-span-2">ACTION</div>
          <div className="col-span-3">TARGET</div>
          <div className="col-span-2">DETAILS</div>
        </div>
        <div className="divide-y divide-zinc-800/70 max-h-[640px] overflow-y-auto" data-testid="audit-list">
          {items.map((a) => (
            <div key={a.audit_id} className="grid grid-cols-12 gap-3 px-4 py-2 font-mono text-[11px] hover:bg-zinc-900/50">
              <div className="col-span-2 text-zinc-500">{a.timestamp.slice(0, 19).replace("T", " ")}</div>
              <div className="col-span-3 text-zinc-200 whitespace-normal break-words">{a.user_email}</div>
              <div className="col-span-2 text-cyan-400 uppercase tracking-widest">{a.action}</div>
              <div className="col-span-3 text-zinc-300 whitespace-normal break-words">{a.target}</div>
              <div className="col-span-2 text-zinc-500 whitespace-normal break-words">{Object.keys(a.details || {}).length ? JSON.stringify(a.details) : "—"}</div>
            </div>
          ))}
          {items.length === 0 && <div className="text-zinc-500 text-sm font-mono px-4 py-10 text-center">no audit records.</div>}
        </div>
      </div>
    </Layout>
  );
}
